export const bgUrl = {
  type: "string",
  minLength: 1,
  maxLength: 2_048
};
